import api from '../api';

const listTools = query => api.get('/api/program-tools/', { params: query });

export default {
  listTools,
};
